import { createSlice } from "@reduxjs/toolkit";

/**
 *
 * @type ClientExitChecklistStoreExitChecklist
 */
const initialState = {
  clientExitChecklistList: { loading: false, data: null, error: null },
  createClientExitChecklist: { loading: false, data: null, error: null },
  updateClientExitChecklist: { loading: false, data: null, error: null },
};

export const ClientExitChecklistSlice = createSlice({
  name: "clientexitchecklist",
  initialState,
  reducers: {
    fetchClientExitChecklistListRequest: (state, action) => {
      state.clientExitChecklistList.loading = true;
      state.clientExitChecklistList.error = null;
    },
    fetchClientExitChecklistListSuccess: (state, action) => {
      state.clientExitChecklistList.data = action.payload;
      state.clientExitChecklistList.loading = false;
      state.clientExitChecklistList.error = null;
    },
    fetchClientExitChecklistListFailure: (state, action) => {
      state.clientExitChecklistList.data = null;
      state.clientExitChecklistList.loading = false;
      state.clientExitChecklistList.error = action.payload;
    },
    createClientExitChecklistRequest: (state, action) => {
      state.createClientExitChecklist.loading = true;
      state.createClientExitChecklist.error = null;
    },
    createClientExitChecklistSuccess: (state, action) => {
      state.createClientExitChecklist.data = action.payload;
      state.createClientExitChecklist.loading = false;
      state.createClientExitChecklist.error = null;
      // state.createClientExitChecklist = addNewClientExitChecklistSuccess(action.payload, {
      //   ...state.clientExitChecklistList,
      // });
    },
    createClientExitChecklistFailure: (state, action) => {
      state.createClientExitChecklist.data = null;
      state.createClientExitChecklist.loading = false;
      state.createClientExitChecklist.error = action.payload;
    },
    updateClientExitChecklistRequest: (state, action) => {
      state.updateClientExitChecklist.loading = true;
      state.updateClientExitChecklist.error = null;
    },
    updateClientExitChecklistSuccess: (state, action) => {
      state.updateClientExitChecklist.data = action.payload;
      state.updateClientExitChecklist.loading = false;
      state.updateClientExitChecklist.error = null;
      console.log(state.clientExitChecklistList,"clientExitChecklistList");
      console.log( action.payload, " action.payload,");
      state.clientExitChecklistList = updateExitChecklistSuccess(
        action.payload,
        {
          ...state.clientExitChecklistList,
        }
      );
    },
    updateClientExitChecklistFailure: (state, action) => {
      state.updateClientExitChecklist.data = null;
      state.updateClientExitChecklist.loading = false;
      state.updateClientExitChecklist.error = action.payload;
    },
  },
});

function addNewClientExitChecklistSuccess(dataToUpdate, state) {
  state.data.data = [...state.data.data, dataToUpdate];
  state.data.total++;
  return state;
}
function updateExitChecklistSuccess(dataToUpdate, state) {
  state.data.data = state.data.data.map((lead) => {
    if (lead._id !== dataToUpdate._id) return lead;
    return { ...lead, ...dataToUpdate };
  });

  return state;
}
export const {
  createClientExitChecklistRequest,
  createClientExitChecklistSuccess,
  createClientExitChecklistFailure,
  fetchClientExitChecklistListRequest,
  fetchClientExitChecklistListSuccess,
  fetchClientExitChecklistListFailure,
  updateClientExitChecklistRequest,
  updateClientExitChecklistSuccess,
  updateClientExitChecklistFailure,
} = ClientExitChecklistSlice.actions;

/**
 *
 * @param {*} store
 * @returns {ClientExitChecklistStoreExitChecklist['ClientExitChecklistList']}
 */
export const getClientExitChecklistListState = (store) =>
  store.clientexitchecklist?.clientExitChecklistList;
export const getClientExitChecklistCreateState = (store) =>
  store.clientexitchecklist?.createClientExitChecklist;
export const getClientExitChecklistUpdateState = (store) =>
  store.clientexitchecklist?.updateClientExitChecklist;
export default ClientExitChecklistSlice.reducer;
